<template>
  <BaseButton class="bg-white inline-flex justify-center items-center" @click="toggleCheck" :value="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)">
    <img class="w-[1.6rem]" :src="imgSrc" :alt="imgAlt" />
    <span class="px-2 py-0 text-black">{{ text }}</span>
    <img class="w-[1.6rem]"
      :src="isChecked ? require('@/assets/images/tic_mark.svg') : require('@/assets/images/Circle_Check.svg')"
      alt="Check Image" />
  </BaseButton>
</template>

<script>

import BaseButton from '@/components/buttons/baseButton.vue';

export default {
  name: 'ImageButtonCheck',
  components: {
    BaseButton
  },
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    imgAlt: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    },
    modelValue: {
      type: [Boolean],
      required: true
    }
  },
  watch: {
    modelValue(newVal) {
      this.isChecked = newVal;
    }
  },
  data() {
    return {
      isChecked: this.modelValue ?? false
    };
  },
  methods: {
    toggleCheck() {
      this.isChecked = !this.isChecked;
      this.$emit('update:modelValue', this.isChecked);
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped></style>
